/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

/* stylelint-disable a11y/media-prefers-reduced-motion */

export const AddReviewerContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  padding: `${token('space.050', '4px')} 0`,
  marginLeft: token('space.100', '8px'),
  transition: 'all 0.1s ease-out',
});
